import React from 'react'
import { AuthLayout } from 'components/Layouts'
import { AuthGuard } from 'routes/components'
import { Login } from 'features/auth/routes'

//config
export const getAuthRoutes = isLoggedIn => {
  return [
    {
      path: '/*',
      element: <AuthGuard isLoggedIn={isLoggedIn} />,
      children: [
        // {
        //   index: !isLoggedIn,
        //   element: 'Home page',
        // },
        {
          element: <AuthLayout />,
          children: [
            {
              path: `login`,
              element: <Login />,
            },
          ],
        },
      ],
    },
  ]
}
